/**
 * Purchase order statuses (purchase_orders.status) and the changes a user may make by hand.
 * Mirrors MANUAL_TRANSITIONS in backend/purchase_orders/service.py (#365): PARTIALLY_RECEIVED and
 * RECEIVED are only set by goods receipts; CANCELLED only while nothing has been received.
 */
export const PO_STATUSES = ['DRAFT', 'SENT', 'CONFIRMED', 'PARTIALLY_RECEIVED', 'RECEIVED', 'CANCELLED'];

export const MANUAL_TRANSITIONS = {
  DRAFT: ['SENT', 'CANCELLED'],
  SENT: ['CONFIRMED', 'CANCELLED'],
  CONFIRMED: ['CANCELLED'],
};

// Lines can change only in these states and before the first receipt
export const LINE_EDITABLE_STATUSES = ['DRAFT', 'SENT', 'CONFIRMED'];

const STATUS_KEYS = {
  DRAFT: 'draft',
  SENT: 'sent',
  CONFIRMED: 'confirmed',
  PARTIALLY_RECEIVED: 'partiallyReceived',
  RECEIVED: 'received',
  CANCELLED: 'cancelled',
};

/** Translated label of a status code (the code itself if unknown). `t` is bound to `procurement`. */
export const poStatusLabel = (t, status) =>
  (STATUS_KEYS[status] ? t(`purchaseOrders.view.status.${STATUS_KEYS[status]}`) : status);

export const PO_STATUS_CLASSES = {
  DRAFT: 'status-inactive',
  SENT: 'status-warning',
  CONFIRMED: 'status-success',
  PARTIALLY_RECEIVED: 'status-info',
  RECEIVED: 'status-info',
  CANCELLED: 'status-error',
};

/** Statuses the status selector offers: the current one plus its manual transitions. */
export const selectableStatuses = (current, hasReceipts) => {
  const next = (MANUAL_TRANSITIONS[current] || []).filter(s => !(s === 'CANCELLED' && hasReceipts));
  return [current, ...next];
};
